import { AlpineComponent } from '@alpinejs/csp';
import { Application } from '@splinetool/runtime';

const SuccessStoryStage = (): AlpineComponent => ({
  visible: false,
  dimmed: false,
  initialized: false,
  canvas: undefined,
  init() {
    const animation = this.$root.dataset.animation;
    const mobileAnimation = this.$root.dataset.mobileAnimation;

    (async () => {
      this.canvas = this.$refs.animation;

      const app = new Application(this.canvas, {
        wasmPath: '/dist/assets/draco/'
      } as any);

      app
        .load(
          window.innerWidth < 768 ? mobileAnimation || animation : animation
        )
        .then(() => {
          setTimeout(() => {
            this.initialized = true;
            this.canvas.style.height = `${window.innerHeight}px`;
          }, 300);
        });
    })();
  },
  handleScroll() {
    const { bottom } = this.$root.getBoundingClientRect();
    this.dimmed = bottom - window.innerHeight * 0.7 < 0;
  },
  handleIntersect() {
    this.visible = true;
  },
  handleIntersectLeave() {
    this.visible = false;
  },
  getClassName() {
    return {
      'success-story-stage--visible': this.visible,
      'success-story-stage--initialized': this.initialized,
      'success-story-stage--dimmed': this.dimmed
    };
  }
});

export default SuccessStoryStage;
